<template>
	<q-form ref="form" :greedy="true" @submit.prevent="emits('nextStep')">

		<subdomain-selector @update:subdomain="onSubdomainChanged"/>

        <q-input v-for="index in wordCount"
                 :key="index"
                 ref="wordRefs"
                 v-model="words[index-1]"
                 :error="hasError[index-1]"
                 :error-message="errorMessages[index-1]"
                 :rules="[
                 val => val && val.length > 0 || 'Please enter your Memorable Tag',
                 val => val.length <= 30 || 'Tag too long',
                 val => isValidWord(val) || 'Only allowed characters a-Z and numbers'
                 ]"
                 class="q-pb-lg"
                 clearable
                 counter
                 label-slot
                 name="memo_link_word[]"
                 outlined
                 type="text"
                 @keydown.tab.enter.prevent="nextField(index-1)">
            <template v-slot:label>
        <span class="text-grey-10 text-caption">
          Type here your
          <span class="q-px-sm bg-deep-orange-4 text-white rounded-borders">Keyword #{{ index }}</span>
        </span>
            </template>
        </q-input>
    </q-form>
    <div class="row-sm column-xs justify-center items-center">
        <q-btn :disable="wordCount<=minKeyWords"
               class="q-mr-sm-md q-mr-md-xl q-mr-xs-none q-mb-xs-md q-mb-sm-none"
               color="deep-orange"
               icon="fa-solid fa-circle-minus"
               label="Remove a Keyword"
               no-caps
               padding="xs md"
               size="md"
               @click="removeWord"
        />
        <q-btn :disable="wordCount>=maxKeyWords"
               color="deep-orange"
               icon="fa-solid fa-circle-plus"
               label="Add a Keyword"
               no-caps
               padding="xs md"
               size="md"
               @click="addWord"
        />
    </div>
</template>

<script setup>
import { computed, inject, nextTick, ref } from 'vue'
import { useQuasar } from 'quasar'
import { useStore } from 'vuex'
import { event } from 'vue-gtag'
import SubdomainSelector from '../../../includes/SubdomainSelector.vue'

const quasar = useQuasar()
const store = useStore()
const eventBus = inject('eventBus');

const form = ref()
const wordCount = ref(1)
const words = ref([])
const hasError = ref([])
const errorMessages = ref([])
const wordRefs = ref([])
const subdomain = ref(null)
const limits = computed(() => store.getters.getLimits)
const minKeyWordsWithSubdomain = computed(() => limits?.value?.getMinMlKeyWordsWithSubdomain()?.value);
const minKeyWords = computed(() => {
    return minKeyWordsWithSubdomain.value;
})

const maxKeyWords = computed(() => limits?.value?.getMaxMlKeyWords()?.value)

defineExpose({ words, wordCount, hasError, errorMessages })
const emits = defineEmits(['nextStep'])

function isValidWord (word) {
    const pattern = new RegExp('^[\\da-zA-Z]+$')

    return !!pattern.test(word.trim())
}

function addWord () {
    if (wordCount.value < maxKeyWords.value) {
        wordCount.value++
        event('more_words_click', { method: 'Google' })
    }
}

function removeWord() {
    if (wordCount.value > minKeyWords.value) {
        if (wordCount.value === 3 && !store.getters.isAuthenticated) {
            event('free_less_words_click', { method: 'Google' })
            openDialog()
        } else {
            wordCount.value--
            wordRefs.value.pop()
            event('less_words_click', { method: 'Google' })
        }
    }
}

function openDialog() {
    eventBus.emit('showLoginDialog');
}

async function nextField(index) {
    const isValid = await wordRefs.value[index].validate();

    if (!isValid) {
        return;
    }

    if (index >= wordRefs.value.length - 1) {
        emits('nextStep')
    } else {
        await nextTick(() => {
            wordRefs.value[index + 1].focus()
            wordRefs.value[index + 1].select()
        })
    }
}

function onSubdomainChanged (val) {
    subdomain.value = val
    checkWordCount()
}

function checkWordCount(){
    if (wordCount.value < minKeyWords.value) {
        wordCount.value = minKeyWords.value
    }
}
</script>

<style scoped>

</style>
